document.addEventListener('DOMContentLoaded', function(dom) {
  const navbar = dom.target.querySelectorAll('.js-navbar')
})

function updateNavbarHeight() {
  const header = document.querySelector('.js-header-container');
  const height = header ? header.offsetHeight : 0;

  document.body.style.setProperty('--navbar-height', `${height}px`);
}

window.addEventListener('load', updateNavbarHeight);
window.addEventListener('resize', updateNavbarHeight);